const technology = [
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Why EVERY Bike Needs One Of These! - BikeRadar",
        "description": null,
        "url": "https://www.youtube.com/watch?v=TSWLb0xzCFY",
        "urlToImage": null,
        "publishedAt": "2023-09-24T14:00:28Z",
        "content": "Your browser isnt supported anymore. Update it to get the best YouTube experience and our latest features. Learn more\r\nRemind me later"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "Divyanshi Sharma",
        "title": "Ex-Google employee says getting fired taught her that her identity does not revolve around her job - India Today",
        "description": "A Google employee lost her job as the company decided to fire hundreds of employees from its recruiting team. In a LinkedIn post, she wrote that losing her job taught her that her identity doesn't revolve around Google.",
        "url": "https://www.indiatoday.in/technology/news/story/ex-google-employee-says-getting-fired-taught-her-that-her-identity-didnt-revolve-around-her-job-2439948-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/google-offers-lucrative-rs-80-000-internship-for-winter-2024--apply-by-oct-1-115540407-16x9.jpg?VersionId=.ZeKISgCHC.LRzs0hmVU_O1GjyOwqLLV",
        "publishedAt": "2023-09-24T13:48:45Z",
        "content": "Google's parent company, Alphabet, made a surprise announcement a couple of days back. The tech giant handed the pink slip to hundreds of employees from its global recruitment team. Just when we thou… [+2652 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Sportskeeda"
        },
        "author": "Neeraj Bansal",
        "title": "What makes Karin Futo GTX so special in GTA Online? - Sportskeeda",
        "description": "GTA Online has many different tuner cars in its catalog, but one vehicle is famous among the community—the Karin Futo GTX.",
        "url": "https://www.sportskeeda.com/gta/what-makes-karin-futo-gtx-special-gta-online",
        "urlToImage": "https://staticg.sportskeeda.com/editor/2023/09/84675-16955603195624-1920.jpg",
        "publishedAt": "2023-09-24T13:29:00Z",
        "content": "GTA Online has many different tuner cars in its catalog, but one vehicle is famous among the communitythe Karin Futo GTX. Being an upgraded version of the regular Futo, the three-door sports model is… [+2633 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Thetechoutlook.com"
        },
        "author": "Blossom Hazarika",
        "title": "Lava Blaze Pro 5G to launch on 26 September 2023 at 12 PM - The Tech Outlook",
        "description": "The Lava Blaze Pro 5G is all set to launch on 26th September 2023 at 12 p.m. on YouTube. The launch event will be live on YouTube. Interested anticipators can join the launch event live on YouTube. Lava has provided a registration link for the same.",
        "url": "https://www.thetechoutlook.com/news/new-release/gadgets-release/mobile/lava-blaze-pro-5g-to-launch-on-26-september-2023-at-12-pm/",
        "urlToImage": "https://www.thetechoutlook.com/wp-content/uploads/2023/09/Lava-Blaze-Pro-5G.jpg",
        "publishedAt": "2023-09-24T13:10:17Z",
        "content": "The Lava Blaze Pro 5G is all set to launch on 26th September 2023 at 12 p.m. on YouTube. The launch event will be live on YouTube. Interested anticipators can join the launch event live on YouTube. L… [+1154 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Broke iPhone 15 series glass back panel? Here’s how much the replacement costs - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/technology/mobile-tabs/broke-iphone-15-series-glass-back-panel-heres-how-much-the-replacement-costs-8953952/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T12:32:25Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "GSMArena.com"
        },
        "author": "Peter",
        "title": "Weekly poll: is the Tecno Phantom V Flip the foldable you've been looking for? - GSMArena.com news - GSMArena.com",
        "description": "The Phantom brand sticks to the affordable side of premium, but did it get the value-for-money balance right with the V Flip?",
        "url": "https://www.gsmarena.com/weekly_poll_is_the_tecno_phantom_v_flip_the_foldable_youve_been_looking_for-news-59955.php",
        "urlToImage": "https://fdn.gsmarena.com/imgroot/news/23/09/weekly-poll-tecno-phantom-v-flip/-952x498w6/gsmarena_000.jpg",
        "publishedAt": "2023-09-24T11:47:01Z",
        "content": "Earlier this year Tecnos premium sub-brand released its first foldable phone, the Phantom V Fold. Now the company has unveiled its first flip foldable too, the Phantom V Flip. While it targets the pr… [+3387 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Amazon Echo Frame, New Fire Tv And Everything Amazon Announced At Its Fall Event - India Today",
        "description": "Amazon's fall event showcased a host of advancements encompassing Alexa, Fire TV, and smart home devices, with emphasis on generative AI models to augment us...",
        "url": "https://www.youtube.com/watch?v=deGJVNeXZ0o",
        "urlToImage": "https://i.ytimg.com/vi/deGJVNeXZ0o/maxresdefault.jpg",
        "publishedAt": "2023-09-24T10:45:13Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "iOS17 Update Now Available For iphone Users In India: 5 Android Features Still Missing In iOS 17 - India Today",
        "description": "In the world of smartphones, two mobile operating systems stand tall: Android and iOS. Of course, both have their unique strengths, but they also have their ...",
        "url": "https://www.youtube.com/watch?v=RtMC4-fy1iU",
        "urlToImage": "https://i.ytimg.com/vi/RtMC4-fy1iU/maxresdefault.jpg",
        "publishedAt": "2023-09-24T10:43:54Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Enhance your productivity with Focus To-Do app; Check out Pomodoro and Tasks features - HT Tech",
        "description": "The Focus To-Do app offers flexibility with customizable Pomodoro and break lengths, notifications, and more.",
        "url": "https://tech.hindustantimes.com/tech/news/enhance-your-productivity-with-focus-to-do-app-check-out-pomodoro-and-tasks-features-71695551526776.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/nbvert_1695551847879_1695551862265.jpg",
        "publishedAt": "2023-09-24T10:41:20Z",
        "content": "In today's fast-paced world, staying focused and managing tasks efficiently can be a challenge. Simply because there are so many of them, especially if you are a multi-tasker. While there are traditi… [+2160 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "As iphone 15 Goes On Sale, People Queue Up And Wait For Hours Outside 2 Apple Stores In India - India Today",
        "description": "Apple fans queued up in long lines — for the first time outside an Apple Store in India — as the iPhone 15 and the iPhone 15 Pro went on sale on November 22....",
        "url": "https://www.youtube.com/watch?v=RGBrvMuFSQo",
        "urlToImage": "https://i.ytimg.com/vi/RGBrvMuFSQo/maxresdefault.jpg",
        "publishedAt": "2023-09-24T10:32:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Jagran.com"
        },
        "author": "Vikas Yadav",
        "title": "Amazon Great Indian Festival Sale 2023 Date LEAKED; Check Offers, Bank Discounts, Smartphone Deals Here - Jagran English",
        "description": "Amazon Great Indian Festival Sale 2023 Start Date Several users posted screenshots of the sale date on microblogging platform X formerly called Twitter For the unversed the e-commerce platform teased the bank offers and additional benefits of the sale on Sept…",
        "url": "https://english.jagran.com/technology/amazon-great-indian-festival-sale-2023-date-leaked-time-offers-bank-discount-smartphone-deals-quiz-10102699",
        "urlToImage": "https://imgeng.jagran.com/images/2023/sep/amazon-great-indian-sale-20231695550173564.jpg",
        "publishedAt": "2023-09-24T10:02:00Z",
        "content": "Amazon Great Indian Sale 2023 Date: Just one day after the announcement of the Amazon Great Indian Festival sale, the date of the highly-anticipated sale has been leaked. Several users posted screens… [+2435 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Statesman"
        },
        "author": "The Statesman",
        "title": "Gmail adds 'Select all' option on Android, to let you select 50 emails at once - The Statesman",
        "description": null,
        "url": "https://www.thestatesman.com/technology/gmail-adds-select-all-option-on-android-to-let-you-select-50-emails-at-once-1503225122.html",
        "urlToImage": null,
        "publishedAt": "2023-09-24T09:45:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Zee Business"
        },
        "author": null,
        "title": "BGMI 2.8 Update Leaks: New Royale Pass, Zombie Mode and More | Check Details - Zee Business",
        "description": "The BGMI 2.8 update is set to release in October, and there are already leaks about what to expect. According to the leaks, the new update will include a new A2 royale pass with new weapon skins, emotes, outfits, and more. The game might also reintroduce its …",
        "url": "https://www.zeebiz.com/technology/video-gallery-bgmi-28-update-leaks-new-royale-pass-zombie-mode-and-more-check-details-255760",
        "urlToImage": "https://cdn.zeebiz.com/sites/default/files/2023/09/24/262009",
        "publishedAt": "2023-09-24T09:36:01Z",
        "content": "By accepting cookies, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts."
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Aman Gupta",
        "title": "Is Elon Musk buying the new iPhone 15? World's richest man says ‘the beauty of iPhone…’ | Mint - Mint",
        "description": "Musk has praised the camera performance of Apple's flagship iPhone series in reply to a post by the Cupertino- based company's CEO Tim Cook.",
        "url": "https://www.livemint.com/technology/tech-news/is-elon-musk-buying-the-new-iphone-15-worlds-richest-man-says-the-beauty-of-iphone-11695541672272.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/TESLA-THAILAND--0_1695547363783_1695547392125.JPG",
        "publishedAt": "2023-09-24T09:32:35Z",
        "content": "Elon Musk, the world's richest man and owner of the social media platform X (formerly Twitter), has often had a love-hate relationship with Apple. Musk was found to be criticising Apple soon after ta… [+2106 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Analytics Insight"
        },
        "author": "Shiva Ganesh",
        "title": "5 Things You Need to Know About Microsoft AI Data Exposure - Analytics Insight",
        "description": "In this article, we will explain 5 things about Microsoft AI data exposure incident, read on to learn more",
        "url": "https://www.analyticsinsight.net/5-things-you-need-to-know-about-microsoft-ai-data-exposure/",
        "urlToImage": "https://www.analyticsinsight.net/wp-content/uploads/2023/09/5-Things-You-Need-to-Know-About-Microsoft-AI-Data-Exposure-.jpg",
        "publishedAt": "2023-09-24T09:31:36Z",
        "content": "What was exposed? \r\nAccording to Wiz, a cloud security startup that discovered the exposure, the URL exposed 38 terabytes of sensitive internal Microsoft data, including private keys, passwords, and … [+2611 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Got your new iPhone 15? Now, know how to use Live Stickers courtesy iOS 17 - HT Tech",
        "description": "Apple iOS 17, which comes packed in the iPhone 15, allows Live Stickers users to cut out backgrounds from their photos and live photos, add effects, and share them seamlessly within the Messages app.",
        "url": "https://tech.hindustantimes.com/how-to/got-your-new-iphone-15-now-know-how-to-use-live-stickers-courtesy-ios-17-71695544419391.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/live_stickers_1695544759872_1695544772345.jpg",
        "publishedAt": "2023-09-24T08:42:04Z",
        "content": "In the ever-evolving world of technology, Apple has once again pushed the boundaries with its latest iOS 17 update. It was rolled out on the iPhone 15 series and a few days later, the software was re… [+2185 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Zoom"
        },
        "author": "Times Now Digital",
        "title": "India Warns Apple Users Of Multiple Weaknesses In iPhone, Apple Watch, MacBook - Times Now",
        "description": "India has issued a 'high severity' warning to Apple users in the country alerting them of vulnerabilities in a number of products of the tech giant, including in the iPhone, Apple Watch and MacBook.",
        "url": "https://www.timesnownews.com/india/india-warns-apple-users-of-multiple-weaknesses-in-iphone-apple-watch-macbook-article-103905541",
        "urlToImage": "https://static.tnn.in/thumb/msid-103905541,updatedat-1695544335681,width-1280,height-720,resizemode-75/103905541.jpg",
        "publishedAt": "2023-09-24T08:32:00Z",
        "content": "Suryakumar Yadav Joins Zaheer Khan, Rohit Sharma In Rare List After Four Consecutive Sixes Off Cameron Green"
    },
    {
        "source": {
            "id": null,
            "name": "Sportskeeda"
        },
        "author": "Mridul Dutta",
        "title": "\"Bully, Max Payne, GTA Liberty City Stories and Chinatown Wars\": Insider thinks Rockstar might include more perks in GTA+ membership - Sportskeeda",
        "description": "Rockstar Games is reportedly preparing to launch some new features for players, with the most recent additions to the GTA+ subscription piquing the community’s interest.",
        "url": "https://www.sportskeeda.com/gta/rumor-bully-max-payne-gta-liberty-city-stories-chinatown-wars-insider-thinks-rockstar-might-include-perks-gta-membership",
        "urlToImage": "https://staticg.sportskeeda.com/editor/2023/09/68b4b-16955420274530-1920.jpg",
        "publishedAt": "2023-09-24T08:20:00Z",
        "content": "Rockstar Games is reportedly preparing to launch some new features for players, with the most recent additions to the GTA+ subscription piquing the communitys interest. Many rumors stated that the Am… [+2223 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "How to enable monochrome mode on Samsung Galaxy smartphones - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/technology/techook/how-to-enable-monochrome-mode-on-samsung-galaxy-smartphones-8953778/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T08:00:11Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Daijiworld.com"
        },
        "author": null,
        "title": "Aim to grow Pokemon GO game users in India 10x in 3 yrs: Top exec - Daijiworld.com",
        "description": "New Delhi, Sep 24 (IANS): As mobile gaming explodes in India with rising number of smartphone users (over 650 million as of now), a top executive of US-based Niantic, the developer behind popular Pokemon GO game, said on Sunday that the company aims to make I…",
        "url": "https://www.daijiworld.com/news/newsDisplay?newsID=1123635",
        "urlToImage": "http://daijiworld.com/images/daijiSquareLogo.png",
        "publishedAt": "2023-09-24T07:17:01Z",
        "content": "New Delhi, Sep 24 (IANS): As mobile gaming explodes in India with rising number of smartphone users (over 650 million as of now), a top executive of US-based Niantic, the developer behind popular Pok… [+2144 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Voltas, Carrier to Daikin, check out these 5 incredible Amazon deals on split ACs; up to 56% discount available - HT Tech",
        "description": "Want to buy a split AC with amazing features at an affordable price? Check out these top 5 deals on Voltas, Carrier, Daikin and other split ACs on Amazon.",
        "url": "https://tech.hindustantimes.com/photos/voltas-carrier-to-daikin-check-out-these-5-incredible-amazon-deals-on-split-acs-up-to-56-discount-available-71695536160519.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/AC3_1695539125246_1695539563404.png",
        "publishedAt": "2023-09-24T07:13:09Z",
        "content": "Top SectionsExplore Tech Copyright © HT Media Limited All rights reserved."
    },
    {
        "source": {
            "id": null,
            "name": "CNBCTV18"
        },
        "author": "Vijay Anand",
        "title": "This startup aims to fly the banking sector into the heart of fintech revolution - CNBCTV18",
        "description": "Falcon, a FinTech infrastructure company co-founded by childhood friends Priyanka Kanwar and Prabhtej Bhatia, has quickly gained momentum, acquiring 40+ enterprise customers, earning $10+ million in annual revenue. Falcon offers advanced FinTech infrastructur…",
        "url": "https://www.cnbctv18.com/technology/falcon-fntech-startup-banking-sector-into-the-heart-of-fintech-revolution-17868011.htm",
        "urlToImage": "https://images.cnbctv18.com/wp-content/uploads/2023/09/falcon-1019x573.jpeg",
        "publishedAt": "2023-09-24T06:58:10Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Sportskeeda"
        },
        "author": "Mridul Dutta",
        "title": "5 of the worst vehicles in GTA Online that should be removed from the game - Sportskeeda",
        "description": "GTA Online offers a selection of over 500 vehicles catering to all players that can be purchased in the multiplayer game. However, most of the vehicles are present in the game, just as showpieces.",
        "url": "https://www.sportskeeda.com/gta/worst-vehicles-gta-online-removed-game",
        "urlToImage": "https://staticg.sportskeeda.com/editor/2023/09/e082a-16955368743178-1920.jpg",
        "publishedAt": "2023-09-24T06:58:00Z",
        "content": "GTA Online offers a selection of over 500 vehicles catering to all players that can be purchased in the multiplayer game. However, most of the vehicles are present in the game, just as showpieces. Th… [+3556 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Found iPhone 15 Pro to be impressive? Now, check what iPhone 16 Pro may pack - HT Tech",
        "description": "The Apple iPhone 15 Pro models have just hit the shelves, but rumours of the iPhone 16 Pro's exciting upgrades are circulating and they point to some really exciting stuff.",
        "url": "https://tech.hindustantimes.com/mobile/news/found-iphone-15-pro-to-be-impressive-now-check-what-iphone-16-pro-may-pack-71695537851272.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/iPhone_15_Pro_1695537990815_1695537991024.png",
        "publishedAt": "2023-09-24T06:48:20Z",
        "content": "The latest Apple iPhone, the iPhone 15 pro, is here, and the company has made it better in so many ways from camera to the charging port. And if you were wishing for more, then know that the iPhone 1… [+2105 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": null,
        "title": "OnePlus Keyboard 81 Pro review: A heavyweight among keyboards - Mint Lounge",
        "description": "At 1.9kg, the OnePlus Keyboard 81 Pro is definitely not a keyboard you can move around, but the heft lends it a premium and luxurious feel",
        "url": "https://lifestyle.livemint.com/smart-living/innovation/oneplus-keyboard-81-pro-review-111695387456036.html",
        "urlToImage": "https://images.livemint.com/img/2023/09/22/1140x641/OnePlus_Keyboard_81_Pro_review_1695388039726_1695388079661.jpg",
        "publishedAt": "2023-09-24T06:36:12Z",
        "content": "Think OnePlus and you are likely to think smartphones, TVs, audio gear, and, more recently, even a tablet. So, to see the brand veer off and make a premium mechanical keyboard came as a bit of a bolt… [+5241 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "Sethu Pradeep",
        "title": "Watch this space: Chandrayaan-3 sleeps as US Space Force punches a hole in atmosphere - The Indian Express",
        "description": "In this week's Watch this Space, Sethu Pradeep writes about how a US Space Force satellite launch may have punched a hole in the atmosphere as ISRO's Chandrayaan-3 mission modules \"slept\" on the Moon.",
        "url": "https://indianexpress.com/article/technology/science/watch-this-space-chandrayaan-3-space-force-8952734/",
        "urlToImage": "https://images.indianexpress.com/2023/09/Watch-this-space-Chandrayaan-3-20230923.jpg",
        "publishedAt": "2023-09-24T06:30:05Z",
        "content": "Despite going long past the end of the missions intended life, the Indian Space Research Organisation (ISRO) stuck out hope for the Chandrayaan-3 mission to be revived after the lunar night. As of no… [+3301 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Samsung might launch S23 FE, Tab S9 FE and Galaxy Buds FE next month - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/technology/tech-news-technology/samsung-galaxy-s23-fe-october-launch-8953614/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T06:10:15Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "From Noise Pulse 2 Max to Fire-Boltt Gladiator, check these 5 best smartwatches on Amazon - HT Tech",
        "description": "Get a trendy smartwatch on Amazon and don't bother to pay the full amount! Just check out these 5 smartwatches that are now quite affordable and have amazing features.",
        "url": "https://tech.hindustantimes.com/wearables/news/from-noise-pulse-2-max-to-fire-boltt-gladiator-check-these-5-best-smartwatches-on-amazon-71695534618686.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/61nAoz3GpRL_SX569__1695535171260_1695535171635.jpg",
        "publishedAt": "2023-09-24T06:00:39Z",
        "content": "Are you a cricket fan and your heartbeat increases as wickets tumble and sixes and fours start raining? So, if you are worried about your health parameters, then you should track them properly and th… [+1774 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Google Pixel 8: New leaked teaser video reveals stunning AI camera features and more - HT Tech",
        "description": "A sneak peek into Google's Pixel 8 series reveals revolutionary AI camera features, including the transformative Magic Editor and DSLR-style manual controls. It is poised to redefine smartphone photography.",
        "url": "https://tech.hindustantimes.com/mobile/news/google-pixel-8-new-leaked-teaser-video-reveals-stunning-ai-camera-features-and-more-71695534610594.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/Google_Pixel_8_1695534760130_1695534760397.jpg",
        "publishedAt": "2023-09-24T05:56:28Z",
        "content": "Google's iconic Pixel series has long been celebrated for its gold-standard camera technology. In 2021, with the Pixel 6 series, Google raised the bar in the world of smartphone photography, leaving … [+2840 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT News Desk",
        "title": "Vivo T2 Pro 5G smartphone launched in India. Check price, features - Hindustan Times",
        "description": "The smartphone is available in two storage options of 8GB+128GB variant and the 8GB+256 GB variant.",
        "url": "https://www.hindustantimes.com/technology/vivo-t2-pro-5g-smartphone-launched-in-india-check-price-features-101695532371708.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/Vivo_T20_Pro_1695534363989_1695534371105.png",
        "publishedAt": "2023-09-24T05:50:02Z",
        "content": "Chinese smartphone giant Vivo unveiled its T2 Pro 5G smartphone in India on Friday. The phone is available for sale from September 29 at 7 pm. \r\nThe smartphone is available in two storage options. Th… [+1750 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "gizmochina"
        },
        "author": "gizmochina",
        "title": "Qualcomm's New Snapdragon 7s Gen 2 Processor is a Secret Rebrand of Last Year's Snapdragon 6 Gen 1 - gizmochina",
        "description": null,
        "url": "https://www.gizmochina.com/2023/09/24/snapdragon-7s-gen-2-rebrand-snapdragon-6-gen-1/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T05:44:53Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "GSMArena.com"
        },
        "author": "Ro",
        "title": "Android 14 might see lock screen widgets return, shortcuts are now customizable - GSMArena.com news - GSMArena.com",
        "description": "We just hope these new options won't be Pixel-exclusive. Remember when Android had widgets on the lock screen? Well, Android 14 might see the return of...",
        "url": "https://www.gsmarena.com/android_14_might_see_lock_screen_widgets_return_shortcuts_are_now_customizable-news-60006.php",
        "urlToImage": "https://fdn.gsmarena.com/imgroot/news/23/08/android-14-beta-5-1/-952x498w6/gsmarena_000.jpg",
        "publishedAt": "2023-09-24T05:23:01Z",
        "content": "Remember when Android had widgets on the lock screen? Well, Android 14 might see the return of such widgets as Mishaal Rahman on X unearthed an intriguing reference in the latest Android 14 beta buil… [+1172 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "India Today Information Desk",
        "title": "How to fix Gmail not working - India Today",
        "description": "Here is how you can easily fix your Gmail when it’s not working.",
        "url": "https://www.indiatoday.in/information/story/how-to-fix-gmail-not-working-2439752-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/gmail-183431-16x9.jpg?VersionId=_yOueMj8dAgUNf3erzZUb2XcTC4uUFFv",
        "publishedAt": "2023-09-24T04:33:06Z",
        "content": "Gmail has become an indispensable part of our daily lives, serving as a reliable platform for email communication. However, like any other technological service, it can encounter issues from time to … [+2399 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "gizmochina"
        },
        "author": "gizmochina",
        "title": "Redmi Note 13 is available now at the Giztop store - gizmochina",
        "description": null,
        "url": "https://www.gizmochina.com/2023/09/24/redmi-note-13-is-available-now-at-the-giztop-store/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T04:20:52Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "News24online.com"
        },
        "author": "Pranjal Gupta",
        "title": "Unbelievable! Create Four Profile From Same Facebook Account; Here’s How - News24",
        "description": "In its latest move, the tech company, Meta, has brought some changes in its social media platform Facebook.",
        "url": "https://news24online.com/tech/unbelievable-create-four-profile-from-same-facebook-account-heres-how-prn/173903/",
        "urlToImage": "https://news24online.com/wp-content/uploads/2023/09/New-Project-2023-09-24T085827.534.jpg",
        "publishedAt": "2023-09-24T03:24:25Z",
        "content": "New Delhi: Meta is rolling out new features almost for everyone to give users a smoother experience. In its latest move, the tech company has brought some changes in its social media platform Faceboo… [+1525 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "Chethan Kumar",
        "title": "Rover wheel imprints show lunar soil is lumpy - IndiaTimes",
        "description": "Bengaluru: The Chandrayaan-3 rover Pragyan, whose rear wheels are embossed with the Indian national emblem and the Isro logo, has been unable to leave.",
        "url": "https://timesofindia.indiatimes.com/city/bengaluru/rover-wheel-imprints-show-lunar-soil-is-lumpy/articleshow/103899251.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103899250,width-1070,height-580,imgsize-14406,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T02:40:00Z",
        "content": "Inside Mouni Roy's festive saree wardrobe"
    },
    {
        "source": {
            "id": null,
            "name": "GSMArena.com"
        },
        "author": "Peter",
        "title": "Weekly poll results: the iPhone 15 Pro Max is the clear fan favorite, the 15 Plus gets no love - GSMArena.com news - GSMArena.com",
        "description": "The Pro Max has exclusivity on Apple's first periscope lens and that is really making a difference. The upgrade to 48MP for the vanilla phones barely tipped the scales.",
        "url": "https://www.gsmarena.com/weekly_poll_results_the_iphone_15_pro_max_is_the_clear_fan_favorite_the_15_plus_gets_no_love-news-59970.php",
        "urlToImage": "https://fdn.gsmarena.com/imgroot/news/23/09/weekly-poll-results-iphone-15-series/-952x498w6/gsmarena_000.jpg",
        "publishedAt": "2023-09-24T02:11:01Z",
        "content": "Last weeks poll leaves no secrets as to which of the new iPhone 15 models is the most popular sure, its expensive, the periscope camera is an unknown and the older models are still competitive, but t… [+2438 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "Quordle 608 answer for September 24: Few obscure words! Check Quordle hints, clues, solutions - HT Tech",
        "description": "Quordle 608 answer for September 24: Win today's Quordle game with the help of the hints and clues given here.",
        "url": "https://tech.hindustantimes.com/how-to/quordle-608-answer-for-september-24-few-obscure-words-check-quordle-hints-clues-solutions-71695518164150.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2023/09/24/1600x900/HT_1695518328970_1695518329221.jpg",
        "publishedAt": "2023-09-24T01:20:39Z",
        "content": "Quordle 608 answer for September 24: Compared to Wordle, Quordle gives you more attempts to crack the answers. However, the thing that you need to note is you have 4 words to find, and that too today… [+1470 chars]"
    }
]


export default technology;